export default __webpack_public_path__ + "static/media/icon3.da3ed2fc.svg";